import {siteModesDimension} from '@packages/systems/designer/site-modes-dimension';
import {abilityFeature} from '../abilityFeature';

export const siteModes = abilityFeature({
  key: 'siteModes',
  isValid: function isSiteModesValid(state, config) {
    return siteModesDimension.isValid(state, config);
  },
});
